import { DownloadButton } from './DownloadButton';
import { LongButtonProps } from './LongButton';

export class ShareButton extends DownloadButton {
    protected getButtonProps(): LongButtonProps {
        const result: LongButtonProps = super.getButtonProps();
        result.icon = undefined;
        result.arrow = !this.props.hideArrow;
        return result;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ShareButton.tsx